import { GraphQLError } from 'graphql'

import { fetchClientByVersion } from '../api/client'
import { getDocumentVerification } from '../api/document'
import { UserLoader } from '../api/user'
import { getDocumentVerificationCp } from '../api_client_portal/document'
import type { DocumentVerification, DocumentVerificationCp, Resolvers } from '../generated/resolvers'

const resolvers: Resolvers = {
  Query: {
    documentVerifications: async (_, { documentId, params }) => {
      const { verifications } = await getDocumentVerification(documentId, params)
      return verifications as DocumentVerification[]
    },
    documentVerificationsCp: async (_, { documentId, params }) => {
      const { verifications } = await getDocumentVerificationCp(documentId, params)

      return verifications as DocumentVerificationCp[]
    },
  },
  Document: {
    verifications: async ({ document_id }) => {
      if (document_id) {
        const { verifications } = await getDocumentVerification(document_id, {})
        return verifications as DocumentVerification[]
      }
      return []
    },
  },
  DocumentVerification: {
    source_user: async ({ source_user_id }) => {
      if (!source_user_id) {
        return null
      }

      const user = await UserLoader.load(source_user_id)

      if (user instanceof GraphQLError) {
        throw user
      }

      return user
    },
    // when the document verification was done from the client portal such as a director signing a document
    source_client: async ({ client_id }) => {
      if (!client_id) {
        return null
      }

      const client = await fetchClientByVersion({ client_id, version: 0 })

      if (client instanceof GraphQLError || !client.details) {
        throw client
      }

      return client.details
    }
  }
}

export default resolvers
